import classNames from "classnames";
import { twMerge } from "tailwind-merge";

interface WebVersionLabelProps {
    className?: string;
}
const WebVersionLabel = ({ className }: WebVersionLabelProps) => (
    <div
        className={classNames(
            "absolute bottom-0 right-2 text-zing-9-14",
            twMerge("text-zing-neutral-cool-grey-700", className)
        )}
    >
        v{process.env.npm_package_version}
    </div>
);

export default WebVersionLabel;
